import Vue from 'vue';
import Router from 'vue-router';
import AuthGuard from './authGuard';
import Pricing from '@/views/Pricing.vue';
import UnrecognizedDevice from '@/views/UnrecognizedDevice.vue';

Vue.use(Router);

const SearchResults = () => import('@/views/SearchResults.vue');
const ShoppingList = () => import('@/views/ShoppingList.vue');
const ShoppingCart = () => import('@/views/ShoppingCart.vue');
const Account = () => import('@/views/Account.vue');
const Login = () => import('@/views/Login.vue');
const Welcome = () => import('@/views/Welcome.vue');
const Search = () => import('@/views/Search.vue');
const ForgotPassword = () => import('@/views/ForgotPassword.vue');
const ResetPassword = () => import('@/views/ResetPassword.vue');
const Register = () => import('@/views/Register.vue');
const MyProjects = () => import('@/views/MyProjects.vue');
const SingleFolder = () => import('@/views/SingleFolder.vue');
const Glossary = () => import('@/views/Glossary.vue');
const SingleRecordDetails = () => import('@/views/SingleRecordDetails.vue');
const StatisticalAnalysis = () => import('@/views/StatisticalAnalysis.vue');
const Help = () => import('@/views/Help.vue');
const SampleRecords = () => import('@/views/SampleRecords.vue');
const EmailVerification = () => import('@/views/EmailVerification.vue');
const LoginFailure = () => import('@/views/LoginFailure.vue');
const Payment = () => import('@/views/Payment.vue');
const SampleRecord = () => import('@/components/help/SampleRecord.vue');
const DeviceVerified = () => import('@/views/DeviceVerified.vue');
const Maintenance = () => import('@/views/Maintenance.vue');

export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash,
            };
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        {
            path: '/',
            name: 'Search',
            component: Search,
            beforeEnter: AuthGuard,
        },
        {
            path: '/welcome',
            name: 'Welcome',
            component: Welcome,
            beforeEnter: AuthGuard,
        },
        {
            path: '/search-results',
            name: 'SearchResults',
            component: SearchResults,
            beforeEnter: AuthGuard,
        },
        {
            path: '/shopping-list',
            name: 'ShoppingList',
            component: ShoppingList,
            beforeEnter: AuthGuard,
        },
        {
            path: '/shopping-cart',
            name: 'ShoppingCart',
            component: ShoppingCart,
            beforeEnter: AuthGuard,
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: AuthGuard,
        },
        {
            path: '/forgot-password',
            name: 'ForgotPassword',
            component: ForgotPassword,
            beforeEnter: AuthGuard,
        },
        {
            path: '/reset-password/:token?',
            name: 'ResetPassword',
            component: ResetPassword,
            beforeEnter: AuthGuard,
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            beforeEnter: AuthGuard,
        },
        {
            path: '/email-verification/:token?',
            name: 'EmailVerification',
            component: EmailVerification,
            beforeEnter: AuthGuard,
        },
        {
            path: '/login-failed',
            name: 'LoginFailed',
            component: LoginFailure,
            beforeEnter: AuthGuard,
        },
        {
            path: '/account/:nested?',
            name: 'Account',
            component: Account,
            beforeEnter: AuthGuard,
        },
        {
            path: '/my-projects',
            name: 'MyProjects',
            component: MyProjects,
            beforeEnter: AuthGuard,
        },
        {
            path: '/single-folder',
            name: 'SingleFolder',
            component: SingleFolder,
            beforeEnter: AuthGuard,
        },
        {
            path: '/glossary',
            name: 'Glossary',
            component: Glossary,
            beforeEnter: AuthGuard,
        },
        {
            path: '/details',
            name: 'SingleRecordDetails',
            component: SingleRecordDetails,
            beforeEnter: AuthGuard,
        },
        {
            path: '/analysis',
            name: 'StatisticalAnalysis',
            component: StatisticalAnalysis,
            beforeEnter: AuthGuard,
        },
        {
            path: '/help',
            name: 'Help',
            component: Help,
            beforeEnter: AuthGuard,
        },
        {
            path: '/sample-records',
            name: 'SampleRecords',
            component: SampleRecords,
            beforeEnter: AuthGuard,
        },
        {
            path: '/payment/:type?',
            name: 'Payment',
            component: Payment,
            beforeEnter: AuthGuard,
        },
        {
            path: '/sample/:id',
            name: 'Sample',
            component: SampleRecord,
            beforeEnter: AuthGuard,
        },
        {
            path: '/pricing/',
            name: 'Pricing',
            component: Pricing,
            beforeEnter: AuthGuard,
        },
        {
            path: '/unrecognized-device',
            name: 'UnrecognizedDevice',
            component: UnrecognizedDevice,
        },
        {
            path: '/device-verification/:token?',
            name: 'DeviceVerified',
            component: DeviceVerified,
        },
        {
            path: '/maintenance',
            name: 'Maintenance',
            component: Maintenance,
        },
    ],
});
